export const createOverviewUrl = (url: string): string => `overview/${url}`;
